<template>
  <div class="com_sponsorlist" :class="_from">
    <div class="sponsor" v-for="(sponsor, key) in contentList" :key="key">
      <div class="sponsor-option">
        <p class="title">{{ key }}</p>
        <ul v-if="sponsor.length > 0">
          <li v-for="(item, index) in sponsor" :key="index">
            <!--   v-if="item.content !== ''" -->
            <a
              :href="item.content === '' ? '#' : item.content"
              target="_blank"
            >
              <img :src="item.file" alt="" />
              <!-- <img :src="item.file + '?imageView2/2/w/160/h/68/q/75'" alt="" /> -->
            </a>
            <!-- <img
              v-else
              :src="item.file + '?imageView2/2/w/160/h/68/q/75'"
              alt=""
            /> -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getSue, sidsponsor, sponsorcontent } from "@/utils/api.js";
export default {
  props: {
    _from: String,
  },
  data() {
    return {
      sponsorList: [],
      cooperatorList: [],
      contentList: {},
    };
  },
  mounted() {
    if(sidsponsor(this.global.year)) {
      this.getSponsor();
    }
  },
  methods: {
    getSponsor() {
      this.$http
        .jsonp(getSue+sidsponsor(this.global.year))
        .then((data) => {
          return data.json();
        })
        .then((res) => {
          // console.log(this.global.year, res);
          if (res.errno == 0) {
            this.splitList(res.data[0]);
            // this.sponsorList = res.data[0];
            // this.cooperatorList = res.data[0];
          } else {
            this.contentList = {...sponsorcontent(this.global.year)};
          }
        });
    },
    splitList(list) {
      this.contentList = {...sponsorcontent(this.global.year)};
      Object.keys(this.contentList).map((item) => {
        this.contentList[item] = [];
      })
      list.map((item) => {
        console.log(item.typeName)
        item.typeName&&this.contentList[item.typeName] ? this.contentList[item.typeName].push(item) : "";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sponsor {
  // width: 1202px;
  margin: 0 auto;
  // padding-bottom: 42px;
  border: 1px solid #edf5fc;
  border-bottom: none;
  border-top: none;
  &:last-child {
    padding-bottom: 50px;
  }
  .sponsor-option {
    p {
      // padding-top: 70px;
      padding-top: 42px;
      padding-bottom: 42px;
      font-size: 24px;
      font-weight: 500;
      font-family: PingFang SC, PingFang SC-Regular;
      text-align: center;
      color: var(--main-color);
    }
    ul {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      li {
        margin-bottom: 30px;
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 180px;
        // img {
        //   height: 68px;
        //   width: 180px;
        // }
      }
    }
  }
}

// new home
.source_home {
  .sponsor {
    width: 100%;
    border: none;
    .sponsor-option {
      max-width: 1200px;
      margin: 0 auto;
      ul {
        li {
          width: 200px;
          height: 80px;
          margin-bottom: 40px;
          display: table;
          a {
            width: 100%;
            height: 100%;
            // display: inline-block;
            display: table-cell;
            vertical-align: middle;
            background: #FFFFFF;
            border-radius: 8px;
            box-shadow: 0px 0px 14px 0px rgba(43, 66, 131, 0.07);
            img {
              width: 100%;
              height: auto;
              object-fit: contain;
              object-position: center;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1023px) {
  .com_sponsorlist:not(.source_home) {
    .sponsor {
      width: 100vw;
      border: none;
      padding-bottom: 0;
      .sponsor-option {
        p {
          font-size: 15px;
          padding-top: 44px;
          padding-bottom: 29px;
        }
        ul {
          margin-bottom: 0;
          li {
            width: 33.33%;
            padding-left: 10px;
            padding-right: 10px;
            a {
              cursor: pointer;
            }
            img {
              max-width: 100%;
              height: auto;
            }
          }
        }
      }
    }
    .sponsor:last-child {
      padding-bottom: 53px;
    }
  }
}

@media (max-width: 767px) {
  .source_home {
    .sponsor {
      .sponsor-option {
        p.title {
          height: auto;
          padding: 0!important;
          padding-top: 35px!important;
          margin-top: 0!important;
          margin-bottom: 10px;
        }
        ul {
          justify-content: space-around;
          li {
            width: 23.4%;
            width: 150px;
            min-width: 150px;
            height: 55px;
            padding: 0;
            margin: 0 5px;
            margin-top: 15px;
            background: #FFFFFF;
            box-shadow: 0px 0px 14px 0px rgb(43 66 131 / 7%);
            border-radius: 8px;
            overflow: hidden;
            display: table;
          }
        }
      }
    }
  }
}
</style>